<template>
  <div class="drag-group-word-question-view">
    <!-- <div class="question-desc-view">{{questioninfo.desc}}</div> -->
    <template
      v-if="questioninfo.content_audio&&questioninfo.content_audio!=''&&questioninfo.content_audio!=null">
      <div class="question-play-btn"
           @click="playcontent(questioninfo.content_audio)">
        <div>听力材料</div>
      </div>
    </template>
    <div class="drag-group-word-question-info-view" :style="showanswertype?'background:#fff':''">
      <div class="drag-drag-group-word-question-content-info-view">
        <div class="group-word-pic">
          <img :src="baseurl+questioninfo.img" :class="showanswertype?'group-word-img':''">
          <div class="show-toast-btn" v-if="!showanswertype" @click="showtoastbtn">提示</div>
        </div>
        <div class="play-word-btn" v-if="showanswertype||showtoasttype" @click="playword"></div>
      </div>
      <div class="drag-drag-group-word-question-content-info-view1">
        <draggable :list="questioninfo.options"
                   :options="{group:{name: flags,pull:'clone'},filter: '.word-undraggable', sort: false,dragClass:'drag-view'}"
                   @end="enddrag"
                   class="drag-group-word-drag1Area">
          <div :id="'drag'+index" class="drag-group-word-drag1Area-item" v-for="(option,index) in questioninfo.options"
               v-if="index<8"
               :data-index="index" @click="clickThis($event)">
            {{option.content}}
          </div>
        </draggable>

        <div class="drag-drop-content-view">
          <template v-for="(choseitem,choseindex) in questioninfo.useroption">
            <draggable :list="choseitem.list"
                       :options="{group:{name: choseitem.flags},filter: '.drag-group-word-content',sort: false,}"
                       :data-index="choseindex"
                       class="drag-group-word-content" :class="gettextbg(showanswertype,questioninfo.answertype)">
              <div v-for="item in choseitem.list" :style="item.content==' '?'width:20px;':''">{{item.content}}</div>
            </draggable>
          </template>
          <div class="clearbtn" v-if="showclear" @click="clearlist"></div>
        </div>

        <draggable :list="questioninfo.options"
                   :options="{group:{name: flags,pull:'clone'},filter: '.word-undraggable', sort: false,dragClass:'drag-view'}"
                   @end="enddrag"
                   class="drag-group-word-drag1Area1" v-if="!showanswertype">
          <div :id="'drag'+index" class="drag-group-word-drag1Area-item" v-for="(option,index) in questioninfo.options"
               v-if="index>=8"
               :data-index="index">
            {{option.content}}
          </div>
        </draggable>
      </div>
    </div>
    <audio ref="wordmusic" controls="controls" style="display: none"
           preload="auto" @ended="playend">
      <source :src="audiourl" type="audio/mpeg">
    </audio>
  </div>
</template>

<script>
  import apiUtil from "@/api/apiUtils"
  import Apis from "@/api"
  import Vue from 'vue';
  import draggable from 'vuedraggable'

  export default {
    name: "draggroupwordquestion",
    components: {draggable},
    data() {
      return {
        baseurl: apiUtil.getBaseUrl(),
        questioninfo: {},
        optionindex: 0,
        answerindex: 0,
        disabled: false,
        flags: "article",
        showclear: false,
        showanswertype: false,
        isCanClick: false,
        showanswerdialog: false,
        audiourl: "",
        showdesc: true,
        showtoasttype: false,
        localindex: 0,
        totalindex: 0,
        contentplay: false,
        descplay: false,
        optioninfos: []
      }
    },
    props: {
      questionData: {
        type: Object,
        default: function () {
          return {}
        }
      },
      isShowHead: {
        type: Boolean,
        default: true
      }
    },
    watch: {
      "questionData": function () {
        this.initData()
      }
    },
    mounted() {
      let _this = this;
      this.$nextTick(() => {
        _this.initData()
      })
    },
    methods: {
      showdescbtn() {
        if (this.showdesc == false) {
          this.showdesc = true;
          this.$refs.wordmusic.pause()
        }
      },
      initData() {
        this.questioninfo = this.paraseData(this.questionData);
        if (this.questioninfo.useroption.length > 0 && this.questioninfo.useroption[0].list.length > 0) {
          setTimeout(() => {
            this.addDiv()
          }, 500)

        }
      },
      addDiv() {
        var doms = document.getElementsByClassName("drag-group-word-drag1Area-item")
        this.questioninfo.useroption.forEach(uitem => {
          uitem.list.forEach((item, index) => {
            for (var i = 0; i < doms.length; i++) {
              var ditem = doms[i];
              if (ditem.dataset.index == item.flags) {
                this.addClass(ditem, "word-undraggable")
              }
            }
          })
        })

      },
      paraseData(questionData) {
        var that = this;
        var questiondata = {};
        if (!questionData.useroption) {
          questiondata = JSON.parse(JSON.stringify(questionData))
          var content = questiondata.content;
          var contents = content.split("|");
          var options = []
          questiondata.contents = []
          questiondata.useroption = []
          questiondata.img = questiondata.content_img;
          contents.forEach(item => {
            options.push({content: item, list: [], flags: "article"})
          })
          var choseinfo = questiondata.answer
          questiondata.useroption.push({
            answer: choseinfo,
            selectindex: [],
            list: [],
            flags: "article"
          })
          var optioninofs = that.randomSort(options);
          questiondata.options = optioninofs;
          this.optioninfos = JSON.parse(JSON.stringify(optioninofs));
          console.log(this.optioninfos)
          questiondata.answers = questiondata.answer;
        } else {
          questiondata = JSON.parse(JSON.stringify(questionData))
          this.showclear = true;
        }
        return questiondata;
      },
      hasClass(elements, cName) {
        return !!elements.className.match(new RegExp("(\\s|^)" + cName + "(\\s|$)"));
      },
      addClass(elements, cName) {
        if (!this.hasClass(elements, cName)) {
          elements.className += " " + cName;
        }
        ;
      },
      removeClass(elements, cName) {
        if (this.hasClass(elements, cName)) {
          elements.className = elements.className.replace(new RegExp("(\\s|^)" + cName + "(\\s|$)"), " ");
        }
      },
      enddrag(ev) {
        if (ev.to.className === "drag-group-word-content") {
          this.isCanClick = true;
          this.questioninfo.useroption[ev.to.dataset.index].selectindex.push(ev.clone.dataset.index)
          this.questioninfo.options[ev.clone.dataset.index].flags = ev.clone.dataset.index
          var dom = document.getElementById("drag" + ev.clone.dataset.index);
          this.addClass(dom, "word-undraggable")
          this.showclear = true;
        } else {
          console.log(this.optioninfos)
          this.questioninfo.options = JSON.parse(JSON.stringify(this.optioninfos))
        }
        this.checkanswer(true)
      },
      clickThis(ev) {
        let _this = this
        if (ev.currentTarget.className.indexOf("word-undraggable") == -1) {
          _this.questioninfo.useroption[0].selectindex.push(ev.currentTarget.dataset.index)
          _this.questioninfo.useroption[0].list.push({content:ev.currentTarget.innerText.trim(),flags:ev.currentTarget.dataset.index,list:[]})
          _this.questioninfo.options[ev.currentTarget.dataset.index].flags = ev.currentTarget.dataset.index
          var doms = document.getElementById("drag" + ev.currentTarget.dataset.index);
          _this.addClass(doms, "word-undraggable")
          _this.showclear = true;
        }
        _this.checkanswer(true)
        _this.$forceUpdate();
        ev.stopPropagation()
      },
      clearlist() {
        this.showclear = false;
        this.questioninfo.useroption.forEach(item => {
          item.list = [];
          item.selectindex = []
        })
        this.questioninfo.options.forEach((item, index) => {
          var dom = document.getElementById("drag" + index);
          if (this.hasClass(dom, "word-undraggable")) {
            this.removeClass(dom, "word-undraggable");
          }
          item.flags = "article"
        })
        this.checkanswer(false)
      },
      checkanswer(isfinish) {
        this.questioninfo.isfinish = isfinish;
        this.$emit("questionfinish", this.questioninfo)
        this.$refs.wordmusic.pause()
      },
      gettextbg(showanswertype, answeertype) {
        if (showanswertype && answeertype) {
          return "answer-right-text"
        } else if (showanswertype && !answeertype) {
          return "answer-wrong-text"
        }
      },
      playword() {
        let that = this;
        var params = {
          'text': that.questioninfo.answers,
          'activity': ""
        }
        apiUtil.httpServer(Apis.getAudioData, params).then(res => {
          if (res.code == 200) {
            that.audiourl = apiUtil.getBaseUrl() + res.data.amazon_url;
            that.$refs.wordmusic.src = that.audiourl;
            if (that.$refs.wordmusic.paused) {
              that.$refs.wordmusic.play()
            }
          }
        })
      },
      showtoastbtn() {
        this.showtoasttype = !this.showtoasttype;
      },
      playdesc(event) {
        let that = this;
        var params = {
          'text': that.questioninfo.desc,
          'activity': ""
        }
        apiUtil.httpServer(Apis.getAudioData, params).then(res => {
          if (res.code == 200) {
            var audiourl = apiUtil.getBaseUrl() + res.data.amazon_url;
            this.$refs.wordmusic.src = audiourl;
            if (that.$refs.wordmusic.paused) {
              that.$refs.wordmusic.play();
              that.descplay = true;
            }
          }
        })
        event.stopPropagation();
      },
      playcontent() {
        var audiourl = apiUtil.getBaseUrl() + this.questioninfo.content_audio;
        this.$refs.groupsentencemusic.src = audiourl;
        if (this.$refs.groupsentencemusic.paused) {
          this.$refs.groupsentencemusic.play()
          this.contentplay = true;
        }
      },
      deschide() {
        this.showdesc = false;
        this.$refs.wordmusic.pause()
      },
      prev() {
        this.$refs.wordmusic.pause()
        this.descplay = false;
        this.contentplay = false;
        this.$emit("goToPrev")
      },
      next() {
        this.$refs.wordmusic.pause()
        this.descplay = false;
        this.contentplay = false;
        this.$emit("goToNext")
      },
      playend() {
        this.descplay = false;
        this.contentplay = false;
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../assets/css/common.styl";
  .drag-group-word-question-view {
    width 100%;
    height 100%;
  }

  .drag-group-word-question-info-view {
    display flex;
    width 100%;
    height 75%;
    position relative;
    display flex;
    justify-content space-around;
    align-items center;
  }

  .drag-drag-group-word-question-content-info-view1 {
    width 70%;
    height 100%;
    margin 10px auto;
    display flex;
    flex-direction column;
    align-items center;
    justify-content center;
  }

  .drag-drag-group-word-question-content-info-view {
    width 30%;
    height 100%;
    margin 10px auto;
    display flex;
    flex-direction column;
    align-items center;
    justify-content space-around;
    position relative;
  }

  .group-word-pic img {
    width 480px;
    height 480px;
  }

  .word-undraggable {
    background: rgba(255, 198, 49, 1) !important;
    border: 3px dashed rgba(189, 189, 189, 1);
    border-radius: 12px;
    color rgba(0, 0, 0, 0) !important;
  }

  .drag-group-word-drag1Area {
    width 100%;
    height 100%;
    display flex;
    align-items center;
    justify-content space-around;
  }

  .drag-group-word-drag1Area1 {
    width 100%;
    height 100%;
    display flex;
    align-items center;
    justify-content space-around;
  }

  .drag-group-word-drag1Area-item {
    font-size 72px;
    background #FF9A09;
    width 120px;
    height 120px;
    border-radius 12px;
    display: flex;
    justify-content center;
    align-items center;
  }

  .drag-group-word-content {
    min-width 500px;
    height 90px;
    margin-right 5px;
    display flex;
    font-size 72px;
    border-bottom 3px solid #5D79FA;
  }

  .answer-right-text {
    border-bottom 3px solid #92C761 !important;
  }

  .answer-wrong-text {
    color: #BDBDBD;
    border-bottom 3px solid #F45578 !important;
  }

  .drag-drop-content-view {
    width 100%;
    display: flex;
    align-items center;
    justify-content center;
  }

  .clearbtn {
    width 50px;
    height 50px;
    position relative;
    left -50px;
    background url("../../assets/img/clear-btn-icon.png")
    background-size 100% 100%;
  }

  .group-word-pic {
    display flex;
    flex-direction column;
    justify-content center;
    align-items center;
    position relative;
  }

  .group-word-img {
    border 3px solid #131313;
  }

  .group-word-pic img {
    border-radius 12px;
  }

  .show-toast-btn {
    background url("../../assets/img/pic-sort-toast.png");
    background-size 100% 100%;
    width 90px;
    height 36px;
    display flex;
    font-size 20px;
    color #fff;
    justify-content center;
    align-items center;
    position absolute;
    left 0;
    bottom 0;
  }

  .play-word-btn {
    background url("../../assets/img/showanswer-play-btn.png")
    background-size 100% 100%;
    width 50px;
    height 50px;
    z-index 10;
    position absolute;
    bottom 20px;
  }

  .group-word-sentent-bottom-view {
    width 100%;
    height 90px;
    position absolute;
    bottom 0;

    .group-word-finish-btn {
      width 50%;
      height 72px;
      font-size 36px;
      position absolute;
      left 25%;
      bottom 30px;
      border-radius 36px;
      background #5777FF;
      color #fff;
    }
  }


  .right-answer-text {
    font-size 72px;
    color #92C761;
    margin-top 15px;
  }

  @media screen and (max-width: 1600px) {

    .group-word-pic img {
      width 300px;
      height 300px;
    }

    .group-word-sentent-bottom-view {
      width 100%;
      height 50px;
      position absolute;
      bottom 0;

      .group-word-finish-btn {
        width 50%;
        height 48px;
        font-size 24px;
        position absolute;
        left 25%;
        bottom 5px;
      }
    }
  }

  @media screen and (max-width: 1366px) {
    .drag-group-word-question-info-view {
      width 100%;
      height 80%;
      position relative;
      display flex;
      justify-content space-around;
      align-items center;
    }

    .group-word-pic img {
      width 300px;
      height 300px;
    }

    .group-word-sentent-bottom-view {
      width 100%;
      height 50px;
      position absolute;
      bottom 0;

      .group-word-finish-btn {
        width 50%;
        height 48px;
        font-size 24px;
        position absolute;
        left 25%;
        bottom 5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/draggroupwordquestion.vue